export const Get_Val_By_ServiceKey = (
  serviceKey,
  DocForm_Json,
  serviceID,
  prev
) => {
  let VALUE = prev ? { ...prev, [serviceKey]: "" } : "";
  const findValueRecursive = (nodes) => {
    if (!Array.isArray(nodes)) {
      console.warn("[Get_Val_By_ServiceKey] nodes is not an array:", nodes);
      return undefined;
    }
    for (const node of nodes) {
      if (serviceID && node.serviceID && node.serviceID.includes(serviceID) && node.serviceKey === serviceKey) {
        return node.val;
      } else if ((node.serviceKey === serviceKey || node.serviceID === serviceID || (node.serviceID && node.serviceID.includes(serviceID))) && node.render === 'true') {
        return node.val;
      }
      if (node.children && node.children.length > 0) {
        const found = findValueRecursive(node.children);
        if (found !== undefined && found !== "") return found;
      }
    }
    return undefined;
  };

  let result = DocForm_Json ? findValueRecursive(DocForm_Json) : undefined;
  if (result !== undefined) {
    VALUE = prev ? { ...prev, [serviceKey]: result } : result;
  }

  return VALUE;
};

export const trim = (str = "") => {
  if (str) return String(str).replace(/\s+/g, "").toLowerCase();
  return "";
};

export const Next_serviceID = (input, num) => {
  let numb = Number(input.split("#").pop()) + num;
  let nextNO = numb.toString().padStart(4, "0");
  let array = input.split("#");
  array[array.length - 1] = nextNO;

  return array.join("#");
};

export const Generate_ServicesID = (input, num) => {
  let numb = 1 + num;
  let nextNO = numb.toString().padStart(4, "0");
  let array = input.split("#");
  array[array.length - 1] = nextNO;

  return array.join("#");
};

export const removeSpecialCharacters_exceptDOT = (str) => {
  return str ? str.replace(/[^\w\s.]/gi, "") : "";
};

export const removeSpecialCharacters = (str) => {
  return str ? str.replace(/[^\w\s]/gi, "") : "";
};

export const generateUniqueNumber = () => {
  var timestamp = new Date().getTime();
  var uniqueNumber = timestamp.toString().substr(0, 10);
  return uniqueNumber;
};

export const base64ToBlob = (base64, mimeType) => {
  const byteArray = Uint8Array.from(atob(base64), (char) =>
    char.charCodeAt(0),
  );
  return new Blob([byteArray], { type: mimeType });
};

export const On_Popup_Table_Search = (VAL, popup_table) => {
  if (!popup_table) return null;

  const data = popup_table.data;
  const filteredData = data.filter((row) =>
    Object.values(row).some(
      (value) =>
        value &&
        value
          .toString()
          .replace(/\s/g, "")
          .toLowerCase()
          .includes(VAL.replace(/\s/g, "").toLowerCase()),
    ),
  );

  return {
    ...popup_table,
    search: VAL,
    filteredData: filteredData || [],
  };
};

export const getFormFields = (json) => {
  let ans = [];
  let themeName;
  let process;
  let ExistingOrgID = "";

  function traverse(node) {
    if (Array.isArray(node)) {
      node.forEach(traverse);
    } else if (typeof node === 'object' && node !== null) {
      if (node.children && Array.isArray(node.children) && node.children.length > 0) {
        if (node.themename && themeName !== node.themename) {
          themeName = !node.themename ? themeName : node.themename
        }
        if (node.processcode && process !== node.processcode) {
          process = !node.processcode ? process : node.processcode
        }
        traverse(node.children);
      } else {
        // Leaf node
        if ((node.scdp === true || (node.render === 'true' && node.editable == 'true')) && node.serviceID) {
          ExistingOrgID = node.val !== "" && (node.serviceKey == "Organization ID" || node.serviceKey == "Receiver ID") ? node.val : ExistingOrgID
          ans.push({
            serviceID: node.serviceID,
            Value: (node.serviceKey == "Organization ID" || node.serviceKey == "Receiver ID") && node.val == "" ? ExistingOrgID : node.val,
            scdp: "true",
            targetField: node.targetField,
            themename: themeName,
            processcode: process,
            range_fn: node?.range_fn,
            DateCheck: node?.DateCheck || "",
            ValueCheck: node?.ValueCheck || ""
          });
        }
      }
    }

  }

  traverse(json);
  return ans.map(item => ({ ...item, Value: item.serviceID?.includes('organizationid') || item.serviceID?.includes('receiverid') ? ExistingOrgID : item.Value }));
};